import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-center bg-slate-300 py-2 -mx-2"
};
const _hoisted_2 = {
  class: "rounded overflow-hidden mr-2 last:mr-0"
};
const _hoisted_3 = {
  class: "uppercase font-bold"
};
const _hoisted_4 = {
  class: "relative h-full -mx-2"
};
const _hoisted_5 = {
  class: "uppercase"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Player, Team } from "@/modules/team/entity";
import ActionPointDisplay from "@/modules/team/components/ActionPointDisplay.vue";
import { PositionAreaEnum } from "@/modules/base/enums";
import TrainingPlayerItem from "@/modules/training/components/TrainingPlayerItem.vue";
import PagesPaginator from "@/modules/vue/components/PagesPaginator.vue";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
import PlayerList from "@/modules/team/components/PlayerList.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const team = ref();
    const players = ref();
    const colorPositionAreaMap = ref({
      [PositionAreaEnum.GK]: ColorEnum.Slate,
      [PositionAreaEnum.DF]: ColorEnum.Amber,
      [PositionAreaEnum.MF]: ColorEnum.Sky,
      [PositionAreaEnum.AT]: ColorEnum.Green
    });
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      players.value = collect(await Player.createQueryBuilder('player').innerJoinAndSelect('player.country', 'country').innerJoin('player.team', 'team').where('team.user = true').getMany()).sortBy('order').groupBy(p => Object.values(PositionAreaEnum).indexOf(p.positionArea)).toArray();
      team.value = await Team.current();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    const valuePositionAreaMap = computed(() => ({
      [PositionAreaEnum.GK]: team.value.actionPointsTrainingGK,
      [PositionAreaEnum.DF]: team.value.actionPointsTrainingDF,
      [PositionAreaEnum.MF]: team.value.actionPointsTrainingMF,
      [PositionAreaEnum.AT]: team.value.actionPointsTrainingAT
    }));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('training')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(ActionPointDisplay, {
          value: team.value.actionPointsTraining,
          icon: _ctx.IconEnum.Dumbbell,
          color: _ctx.ColorEnum.Red,
          class: "rounded-xl w-12 h-full"
        }, null, 8, ["value", "icon", "color"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(PositionAreaEnum)), area => {
          return _openBlock(), _createElementBlock("div", {
            key: area,
            class: "rounded overflow-hidden mr-2 last:mr-0"
          }, [_createVNode(ActionPointDisplay, {
            value: _unref(valuePositionAreaMap)[area],
            color: colorPositionAreaMap.value[area],
            class: "rounded-xl w-12 h-full"
          }, {
            icon: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(area), 1)]),
            _: 2
          }, 1032, ["value", "color"])]);
        }), 128))]), _createElementVNode("div", _hoisted_4, [_createVNode(PagesPaginator, {
          "all-items": players.value
        }, {
          default: _withCtx(({
            items
          }) => [_createVNode(PlayerList, {
            players: items.toArray(),
            "no-action": ""
          }, {
            player: _withCtx(({
              player
            }) => [_createVNode(TrainingPlayerItem, {
              player: player,
              onTrained: _unref(refresh)
            }, null, 8, ["player", "onTrained"])]),
            _: 2
          }, 1032, ["players"])]),
          display: _withCtx(({
            currentPage
          }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(Object.values(_unref(PositionAreaEnum))[currentPage - 1]), 1)]),
          _: 1
        }, 8, ["all-items"])])]),
        _: 1
      });
    };
  }
});